// redirect if no data
if(!localStorage.getItem('fuelling-data')){
  //window.location.href = 'https://styrkr.com/pages/fuelling-guide'
}

// note: how to retrieve local storage:
var fuellingData = JSON.parse(localStorage.getItem('fuelling-data'));
var customerData = JSON.parse(localStorage.getItem('customer-data'));

function generateCopy(){
  // display the correct product recommendation
  let option_1 = document.querySelector('.product-sticky:first-of-type');
  let option_2 = document.querySelector('.product-sticky:last-of-type');
  (fuellingData.duration > 4) ? option_1.style.display = 'none' : option_2.style.display = 'none';
  // name
  document.querySelector('#customer-name').textContent = customerData.firstName; 
  // activity
  let supported = fuellingData.supported ? 'supported' : 'unsupported';
  let sport = (fuellingData.activity === 'Other') ? 'exercise' : fuellingData.activity;
  let activity = 'Activity: ' + fuellingData.intensity + ' ' + supported + ' ' + sport;
  let intensity = fuellingData.intensity
  // pdf download URL
  let answersUrl = `https://styrkr.bundles.sites.k-hosting.co.uk/generate_fuel_pdf.php?activity=${fuellingData.activity}&supported=${fuellingData.supported}&intensity=${fuellingData.intensity}&duration=${fuellingData.duration}&download=1`;
  document.querySelector('#download-button').href = answersUrl;
  // general copy inserts
  document.querySelectorAll('.sport').forEach(sportText => sportText.textContent = sport);
  document.querySelectorAll('.activity').forEach(activityText => activityText.textContent = activity);
  document.querySelectorAll('.supported').forEach(supportedText => supportedText.textContent = supported);
  document.querySelectorAll('.intensity').forEach(intensityText => intensityText.textContent = intensity);
  // duration
  document.querySelectorAll('.duration-2').forEach(durationText => durationText.textContent = fuellingData.duration + ' hours');
  document.querySelectorAll('.duration').forEach(durationText => durationText.textContent = 'Duration: ' + fuellingData.duration + ' hours');
  // advice 1
  document.querySelectorAll('.advice_1').forEach(adviceText => adviceText.textContent = fuellingData.advice1);
  // carbs
  const totalCarbs = fuellingData.hoursCollection.items.reduce((allTotal, productsCollection ) => {
        const sum = productsCollection.productsCollection.items.reduce((total, product) => {
          return total + product.carbs ;
        }, 0);
        return allTotal + sum;
      }, 0);
  
  document.querySelector('#total-carbs').textContent = totalCarbs + 'g';
  
  // cals
  const totalCals = fuellingData.hoursCollection.items.reduce((allTotal, productsCollection ) => {
        const sum = productsCollection.productsCollection.items.reduce((total, product) => {
          return total + product.calories;
        }, 0);
        return allTotal + sum;
      }, 0);
  
  document.querySelector('#total-cals').textContent = totalCals + ' kcal';
  
  // cals from food
  document.querySelector('#total-food').textContent = fuellingData.caloriesRequiredFromFood + ' kcal';
}

generateCopy();

function generateTable(){

  for (const [hour, data] of Object.entries(fuellingData.hoursCollection.items)) {
    if(data.productsCollection.items.length < 1){
      createTableMarkup(data, hour, true)
    } else {
      createTableMarkup(data, hour, false)
    }
  }

}

function createTableMarkup(data, hour, noProducts){

    const table = document.querySelector('#fuelling-hours');
    
    // add a table row
    let tableRow = table.insertRow(-1);
    
    // hour cell
    let hourCell = tableRow.insertCell(0);
    let hourSpan = document.createElement('span')
    
    // Append a text node to the cell
    let hourCopy = (hour == 0) ? 'Start' : 'Hour ' + hour;
    let newText = document.createTextNode(hourCopy);
    hourSpan.appendChild(newText);
    hourCell.appendChild(hourSpan);
    
    
    // product cell
    let productCell = tableRow.insertCell(1);
    
    if(noProducts){
      tableRow.classList.add('no-fuel');
    } else {

      for (const [index, product] of Object.entries(data.productsCollection.items)) {
        let productLink = document.createElement('a');
        let productName = document.createTextNode(product.name);
        productLink.appendChild(productName);
        productLink.href = product.url;
        productLink.target = "_blank";
        productCell.appendChild(productLink);

        // see if another product is in this hour
        if (index != Object.entries(data.productsCollection.items).length - 1) {
          let lineBreak = document.createElement('br');
          productCell.appendChild(lineBreak);
        }
      }
    }
    
    
    
}

generateTable();


// add to cart functions

var singlePurchase = document.querySelector('.product-page-add');

if(singlePurchase){
  document.querySelectorAll('.product-page-add').forEach(productAdd => {
      productAdd.addEventListener('click', e =>{
       var quantity = productAdd.parentElement;
       productAdd.textContent = 'Adding…';
       cartAdd(productAdd.dataset.purchaseId ,1).then((response) => {
         if(response.status == 422){
           productAdd.textContent = 'Not enough stock';
           productAdd.style.backgroundColor = "red";
         } else {
            return updateCart();
         }
       })
       .then( ()=> {
           productAdd.textContent = 'Add to basket';
          toggleElement(cartDrawer, e)
       });
    });
  });
}

// toggle accordion for fuel questions

function toggleAccordion(e){
	
	let question = e.currentTarget;
	let answer = question.nextElementSibling;
  	let container = question.parentElement;
	
	if(!question.classList.contains('active')){
		
		document.querySelectorAll('.fuel-question-container, .fuel-question, .fuel-answer').forEach(el => {
			el.classList.remove('active');
			el.style.maxHeight = null;
		});
		
		question.classList.add('active');
		answer.classList.add('active');
        container.classList.add('active');
      
		
		if (answer.style.maxHeight) {
		  answer.style.maxHeight = null;
		} else {
		  answer.style.maxHeight = (answer.scrollHeight + 74) + "px";
		}
		
		if(window.matchMedia('max-width: 39.9375em').matches){
			setTimeout(function(){
				let t = question.getBoundingClientRect().top + window.pageYOffset - 70;
		        window.scrollTo({
		            top: t,
		            behavior: "smooth"
		        })
			}, 300);
		}
	} else {
				
		document.querySelectorAll('.fuel-question-container, .fuel-question, .fuel-answer').forEach(el => {
			el.classList.remove('active');
			el.style.maxHeight = null;
		});
	}
    
}

if(document.querySelector('.fuel-question-container')){
	document.querySelectorAll('.fuel-question').forEach(fuelQuestion => {
		fuelQuestion.addEventListener('click', toggleAccordion);
	})
}